const CheckTokenExpire = (tokens) => {
    const decodeJwt = ParseJwt(tokens);
    if((decodeJwt.exp * 1000) < Date.now()){
        return true;
    }
    return false;
};

const ParseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};

const getStepWorkflowByIdWorkFlow = (idWorkflow) => {
    const arrStep = [
        {"step": 1, "id_work_flow": [1,4]},
        {"step": 2, "id_work_flow": [2,3]},
        {"step": 3, "id_work_flow": [5,6]},
        {"step": 4, "id_work_flow": [7,9,12]},
        {"step": 5, "id_work_flow": [8,11,13,14]},
        {"step": 6, "id_work_flow": [10]},
        {"step": 7, "id_work_flow": [15,16,20]},
        {"step": 8, "id_work_flow": [17,18,19]},
        {"step": 9, "id_work_flow": [21]},
        {"step": 10, "id_work_flow": [22]}
    ];
    const step = arrStep.find((e) => e.id_work_flow.includes(idWorkflow));
    return (step !== undefined) ? step.step : 0;
};

const getServiceFee = (serviceFee) => {
    var price = parseFloat(serviceFee);
    var result = !isNaN(price) ? Number(serviceFee).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-";
    return result;
};

const getDomain = (email) => {
    const domain = email?.split('@')[1] || "";
    const lowercaseString = domain?.toLowerCase();

    return lowercaseString;
};

const getFillArray = (arrValue, targetLength, modelData) => {
    const numForAdd = targetLength - arrValue.length;
    const newArrValue = Array(numForAdd).fill(modelData);
    return [...arrValue, ...newArrValue];
};

// const ValidateNumber = (event) => {
//     // Enhanced regex for numbers, commas, decimals, spaces, and '.00' after digits
//     const regex = /^(?:[0-9,.\s]*|\.[0-9]{0,2}(?:\s|$)|[0-9,.\s]+\.[0-9]{1,2}(?:\s|$)|[0-9,]+\.00)$/;

//     // Validate input against the regex
//     if (event.target.value === "" || !regex.test(event.target.value)) {
//         // Remove invalid characters
//         event.target.value = event.target.value.slice(0, event.target.value.length - 1);
//     } else if (event.target.key === '.') {
//         const currentValue = event.target.value;
//         const cursorPosition = event.target.selectionStart;

//         // Check for dot at the end or after a digit
//         if ((cursorPosition === currentValue.length && /[0-9]/.test(currentValue[cursorPosition - 1])) || !currentValue.includes('.')) {
//             event.target.value += '.00';
//         } else {
//         // Prevent adding a second decimal point
//             event.preventDefault();
//         }
//     }

//     // Extract integer and decimal parts (considering ".00" as two decimals)
//     const value = event.target.value;
//     const parts = value.split('.');
//     const integerPart = parts[0].replace(/,/g, "");

//     let decimalPart = "";
//     if (parts.length === 2) {
//         if(parts[1] === ""){
//             decimalPart = '00';
//         } else {
//             decimalPart = parts[1].slice(0, 2); // Limit decimals to 2
//         }
//     } else if (parts.length === 3 && parts[2] === '00') {
//         // Handle ".00" case (consider as two decimals)
//         decimalPart = '00';
//     }
//     // Format integer part with commas every 3 digits
//     const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d|\.))/g, ',');

//     // Update input value with formatted number
//     event.target.value = `${formattedInteger}${decimalPart ? `.${decimalPart}` : ""}`;

//     return event;
// };
const ValidateNumber = (event) => {
    let value = event.target.value;

    // อนุญาตเฉพาะตัวเลข, comma และจุดทศนิยม
    value = value.replace(/[^0-9.,]/g, "");

    // ตรวจสอบว่ามีจุดมากกว่าหนึ่งตัวหรือไม่
    let dotCount = (value.match(/\./g) || []).length;
    if (dotCount > 1) {
        value = value.substring(0, value.lastIndexOf(".")); // ลบจุดที่เกินออก
    }

    // แยกส่วนจำนวนเต็มกับทศนิยม
    let parts = value.split(".");

    // เอา comma ออกจากจำนวนเต็มก่อน Format ใหม่
    let integerPart = parts[0].replace(/,/g, "");

    // ตรวจสอบว่า integer เป็นตัวเลข ไม่ให้เริ่มต้นด้วย 0 ถ้ามีค่ามากกว่า 1 หลัก
    if (integerPart.length > 1 && integerPart.startsWith("0")) {
        integerPart = integerPart.slice(1);
    }

    // เพิ่ม comma คั่นหลักพัน
    let formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // จำกัดทศนิยมไม่เกิน 2 ตำแหน่ง
    let decimalPart = parts[1] !== undefined ? parts[1].substring(0, 2) : "";

    // ถ้ามีจุด ให้คืนค่าโดยจำกัดทศนิยม 2 ตำแหน่ง
    event.target.value = decimalPart !== "" ? `${formattedInteger}.${decimalPart}` : value.includes(".") ? `${formattedInteger}.` : formattedInteger;

    return event;
};

const ValidateNumberWithoutDecimal = (event) => {
    let value = event.target.value;

    // อนุญาตเฉพาะตัวเลขและ comma (ไม่รวม .)
    value = value.replace(/[^0-9,]/g, "");

    // เอา comma ออกจากจำนวนเต็มก่อน Format ใหม่
    let integerPart = value.replace(/,/g, "");

    // ตรวจสอบว่า integer เป็นตัวเลข ไม่ให้เริ่มต้นด้วย 0 ถ้ามีค่ามากกว่า 1 หลัก
    if (integerPart.length > 1 && integerPart.startsWith("0")) {
        integerPart = integerPart.slice(1);
    }

    // เพิ่ม comma คั่นหลักพัน
    let formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // อัปเดตค่าของ input
    event.target.value = formattedInteger;

    return event;
};

const formatNumberWithComma = (value) => {
    if (value === null || value === undefined || value === "") return "";
  
    const hasTrailingDot = value.endsWith(".");
  
    let [integerPart, decimalPart] = value.split(".");
  
    integerPart = integerPart.replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
    // ถ้าทศนิยมคือ "00" (เท่านั้น) ให้ตัดออก
    if (decimalPart === "00") {
      return integerPart;
    }
  
    if (decimalPart !== undefined && decimalPart !== "") {
      return `${integerPart}.${decimalPart}`;
    }
  
    // กรณีแค่พิมพ์จุดยังไม่เสร็จ
    if (hasTrailingDot) {
      return `${integerPart}.`;
    }
  
    return integerPart;
  };

export { CheckTokenExpire, ParseJwt, getStepWorkflowByIdWorkFlow, getServiceFee, getDomain, getFillArray, ValidateNumber, formatNumberWithComma, ValidateNumberWithoutDecimal };